import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgError = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 118,
	height: 91,
	fill: "none",
	viewBox: "0 0 118 91",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#pet__clip0_10505_3323)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "white",
				d: "M26.4537 90.1712H12.7153C11.8343 90.172 10.9686 89.9411 10.2053 89.5016C9.44199 89.0621 8.80802 88.4295 8.36715 87.6676C7.92628 86.9056 7.69406 86.0411 7.69385 85.161C7.69364 84.281 7.92545 83.4163 8.36596 82.6542L12.3931 75.7003L29.871 45.5288L51.3416 8.38041C51.782 7.61906 52.4153 6.98687 53.1777 6.54736C53.9401 6.10784 54.8049 5.87646 55.6852 5.87646C56.5655 5.87646 57.4302 6.10784 58.1927 6.54736C58.9551 6.98687 59.5883 7.61906 60.0288 8.38041L81.4993 45.5288L102.97 82.6772C103.404 83.4379 103.631 84.299 103.629 85.1748C103.626 86.0505 103.394 86.9103 102.955 87.6684C102.516 88.4265 101.886 89.0565 101.128 89.4957C100.369 89.9348 99.5087 90.1677 98.632 90.1712H34.0708"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "white",
				d: "M56.4872 56.4169C56.4872 56.625 56.2769 59.0869 56.2535 59.2834V59.3528C55.9911 60.3582 55.3942 61.247 54.5588 61.876C53.7235 62.5051 52.6983 62.8377 51.6485 62.8203C50.6373 62.8169 49.6609 62.4544 48.8972 61.7989C48.1335 61.1434 47.6333 60.2384 47.4876 59.2487L45.5825 30.8958C45.5825 30.7108 45.5825 30.5259 45.5825 30.341C45.581 29.5659 45.734 28.7981 46.0329 28.0816C46.3318 27.365 46.7706 26.7138 47.3243 26.1652C47.8779 25.6166 48.5356 25.1814 49.2595 24.8844C49.9835 24.5874 50.7595 24.4346 51.5433 24.4346C54.8393 24.4346 58.2638 27.0815 58.2638 30.341L56.7911 51.4468L56.4872 56.4169Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "white",
				d: "M52.1744 79.8228C55.4084 79.8228 58.03 77.2302 58.03 74.032C58.03 70.8338 55.4084 68.2412 52.1744 68.2412C48.9405 68.2412 46.3188 70.8338 46.3188 74.032C46.3188 77.2302 48.9405 79.8228 52.1744 79.8228Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#D8DEE3",
				d: "M108.586 82.7913L108.425 82.5081C107.946 81.5502 107.602 80.8693 107.466 80.5923L96.4336 61.9134L64.437 7.30671C63.2562 5.26967 59.9272 5.47032 58.4361 7.66127L58.1691 8.04787C58.6624 8.0617 59.1442 8.19842 59.5699 8.44535C59.9956 8.69228 60.3514 9.04144 60.6044 9.4605L92.5962 64.3081L100.619 77.4695C104.233 84.0035 107.466 91.1292 90.5588 90.2511L102.953 90.6502C104.108 90.6502 104.783 90.5644 105.547 90.2511C106.312 89.9378 106.931 89.3594 107.466 88.7344C108.665 87.1895 109.385 84.9029 108.586 82.7913Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#D8DEE3",
				d: "M59.2689 58.6939C59.2863 58.8901 59.2863 59.0873 59.2689 59.2834V59.3528C59.007 60.3562 58.4119 61.2436 57.5789 61.8724C56.7459 62.5012 55.7235 62.8351 54.6756 62.8203C53.667 62.8206 52.6926 62.4587 51.9337 61.8017C51.1748 61.1447 50.683 60.2375 50.5498 59.2487L48.5278 30.8958C48.5278 30.7108 48.5278 30.5259 48.5278 30.341C48.5263 29.5659 48.6794 28.7981 48.9782 28.0816C49.2771 27.365 49.7159 26.7138 50.2696 26.1652C50.8232 25.6166 51.4809 25.1814 52.2048 24.8844C52.9288 24.5874 53.7049 24.4346 54.4886 24.4346C57.7846 24.4346 61.2091 27.0815 61.2091 30.341L59.2689 58.6939Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#D8DEE3",
				d: "M55.3536 79.3145C58.5876 79.3145 61.2092 76.7219 61.2092 73.5237C61.2092 70.3255 58.5876 67.7329 55.3536 67.7329C52.1197 67.7329 49.498 70.3255 49.498 73.5237C49.498 76.7219 52.1197 79.3145 55.3536 79.3145Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#CFD4DC",
				d: "M11.5315 42.2769C12.0404 42.2769 12.5284 42.075 12.8882 41.7158C13.248 41.3565 13.4502 40.8692 13.4502 40.3611C13.4502 39.853 13.248 39.3657 12.8882 39.0064C12.5284 38.6472 12.0404 38.4453 11.5315 38.4453C11.0226 38.4453 10.5346 38.6472 10.1748 39.0064C9.81494 39.3657 9.61279 39.853 9.61279 40.3611C9.61279 40.8692 9.81494 41.3565 10.1748 41.7158C10.5346 42.075 11.0226 42.2769 11.5315 42.2769Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#CFD4DC",
				d: "M107.172 53.1517C107.602 53.1517 108.015 52.9825 108.32 52.6814C108.624 52.3802 108.796 51.9717 108.796 51.5458C108.796 51.1199 108.624 50.7115 108.32 50.4103C108.015 50.1091 107.602 49.9399 107.172 49.9399C106.741 49.9399 106.328 50.1091 106.023 50.4103C105.719 50.7115 105.548 51.1199 105.548 51.5458C105.548 51.9717 105.719 52.3802 106.023 52.6814C106.328 52.9825 106.741 53.1517 107.172 53.1517Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FFB5B5",
				d: "M5.54954 36.9674C6.26433 36.9674 6.96304 36.7576 7.5572 36.3646C8.15137 35.9717 8.61426 35.4132 8.88726 34.7599C9.16026 34.1066 9.2311 33.3879 9.0908 32.6948C8.9505 32.0016 8.60536 31.3652 8.09911 30.8662C7.59286 30.3672 6.94826 30.0279 6.24692 29.8914C5.54558 29.7549 4.81906 29.8273 4.15935 30.0994C3.49964 30.3715 2.9364 30.8311 2.54097 31.42C2.14554 32.0088 1.93569 32.7005 1.93801 33.4074C1.9411 34.3526 2.32297 35.2581 2.99992 35.9254C3.67688 36.5927 4.59373 36.9674 5.54954 36.9674Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#CBD1DC",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.4,
				d: "M112.867 42.2769V50.9688"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#CBD1DC",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.4,
				d: "M108.426 46.5767H117.309"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#778087",
				strokeLinecap: "round",
				strokeMiterlimit: 10,
				strokeWidth: 1.4,
				d: "M20.8746 90.1561H6.19472C5.2514 90.1606 4.32357 89.919 3.50478 89.4557C2.686 88.9925 2.00521 88.3239 1.53108 87.5174C1.05694 86.7109 0.806227 85.795 0.804211 84.8622C0.802196 83.9293 1.04895 83.0124 1.5196 82.2039L5.84408 74.8527L24.5446 42.8472L47.5345 3.46742C48.0029 2.65798 48.6793 1.98529 49.4951 1.51745C50.311 1.04961 51.2373 0.803223 52.1804 0.803223C53.1234 0.803223 54.0498 1.04961 54.8656 1.51745C55.6814 1.98529 56.3578 2.65798 56.8263 3.46742L79.8278 42.8472L102.853 82.2385C103.315 83.0461 103.554 83.9593 103.548 84.8871C103.542 85.8149 103.289 86.7248 102.816 87.5261C102.343 88.3273 101.666 88.9918 100.852 89.4533C100.038 89.9148 99.1159 90.1571 98.1777 90.1561H29.0327"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#778087",
				strokeMiterlimit: 10,
				strokeWidth: 1.4,
				d: "M56.4872 56.4169C56.4872 56.625 56.2769 59.0869 56.2535 59.2834V59.3528C55.9911 60.3582 55.3942 61.247 54.5588 61.876C53.7235 62.5051 52.6983 62.8377 51.6485 62.8203C50.6373 62.8169 49.6609 62.4544 48.8972 61.7989C48.1335 61.1434 47.6333 60.2384 47.4876 59.2487L45.5825 30.8958C45.5825 30.7108 45.5825 30.5259 45.5825 30.341C45.581 29.5659 45.734 28.7981 46.0329 28.0816C46.3318 27.365 46.7706 26.7138 47.3243 26.1652C47.8779 25.6166 48.5356 25.1814 49.2595 24.8844C49.9835 24.5874 50.7595 24.4346 51.5433 24.4346C54.8393 24.4346 58.2638 27.0815 58.2638 30.341L56.7911 51.4468L56.4872 56.4169Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#778087",
				strokeMiterlimit: 10,
				strokeWidth: 1.4,
				d: "M52.1744 79.8228C55.4084 79.8228 58.03 77.2302 58.03 74.032C58.03 70.8338 55.4084 68.2412 52.1744 68.2412C48.9405 68.2412 46.3188 70.8338 46.3188 74.032C46.3188 77.2302 48.9405 79.8228 52.1744 79.8228Z"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "pet__clip0_10505_3323",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 118,
			height: 91,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgError);
export default ForwardRef;
